
<template>
  <div class="inquiry-company">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">公司管理</div>
        <div class="select-container" style="margin-top: 0px;">
          <div class="select-container-box">
            <span>查询：</span>
            <el-input
              placeholder="请输入公司名称查询"
              v-model="keyword"
              prefix-icon="el-icon-search"
              size="small"
              type="text"
              :maxlength="20"
              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
              class="search-input"
              clearable
            >
            </el-input>
          </div>
          <div class="select-container-box">
            <span>公司状态：</span>
            <el-select v-model="IsAuth" placeholder="请选择" style="width: 150px;">
              <el-option label="未认证公司" :value="true"></el-option>
              <el-option label="已认证公司" :value="false"></el-option>
              <el-option label="全部公司" value=""></el-option>
            </el-select>
          </div>

          <div class="select-container-box">
            <el-button
              size="small"
              type="info"
              plain
              class="query"
              @click="search(1)"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <div class="table-container">
        <el-table :data="list" style="width: 100%" size="medium" border>
          <i slot="empty" style="font-style: normal">该时间段暂无数据</i>
          <el-table-column
            prop="enterpriseName"
            label="公司名"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建日期"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          
          <el-table-column
            label="认证"
            align="center"
          >
            <template slot-scope="scope">
              <!-- <span class="tool-text blue">编辑权限</span> -->
              <el-switch :value="scope.row.isAuth" :active-value="true" :inactive-value="false" @change="(e) => handleAuth(e, scope.row.enterpriseId) "></el-switch>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change>
    </div>
  </div>
</template>

<script>
import { MessageBox, Message } from "element-ui";
import PageChange from "@/components/common/PageChange";
export default {
  name: "UserManage",
  data() {
    return {
      keyword: "",
      IsAuth: true,
      list: [],
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.search, // 当前页数需要调用的函数
        pageSize: 10 // 当前页数
      }
    };
  },
  components: {
    PageChange
  },
  async mounted() {
    // this.search();
  },
  methods: {
    async search() {
      let res = await this.$api.getPlatformEnterprisePage({
        Keyword: this.keyword,
        IsAuth: this.IsAuth,
        PageIndex: this.pageInfo.pageNumber,
        PageSize: this.pageInfo.pageSize
      });
      console.log(res);
      res.data.list.map(item => {
        item.createTime = item.createTime.substring(0, 16).replace("T", " ");
      });
      this.pageInfo.totalPages = res.data.total;
      this.list = res.data.list;
    },
    async handleAuth(isEnable, enterId){
      const text = isEnable? '认证' : '取消认证'
      const confirmResult = await this.$confirm('确认要' + text + '此公司吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') return
      const res = await this.$api.updatePlatformEnterStatus({ enterId, isEnable })
      if (res.status !== 200) return this.$message.error(res.data)
      this.$message.success('公司认证状态更新成功！')
      this.search()
    }
  }
};
</script>
<style lang="stylus" >
.inquiry-company {
  .el-table {
    .el-table__body tbody td {
      border-bottom: 1px solid #eee;
    }

    .el-table__row:nth-of-type(even) {
      background: #fff;
      z-index: 9999;
    }
  }

  .total {
    .el-select__tags {
      top: 65%;
      height: 30px;
      overflow: auto;
    }

    .el-input__suffix {
      top: 6px;
    }

    .is-focus .el-input__suffix {
      top: 0px;
    }
  }

  .select-container-box:nth-child(1), .select-container-box:nth-child(3) {
    .el-input--small {
      width: 220px !important;
      height: 38px !important;
      min-width: 135px !important;
    }
  }

  .select-container-box:nth-child(6), .select-container-box:nth-child(7) {
    .el-input--small {
      width: 96px !important;
      height: 38px !important;
      min-width: 96px !important;
    }
  }

  .select-container-box:nth-child(9) {
    .add, .query {
      width: 80px !important;
    }
  }

  .scroll-box3 {
    width: 100%;
    max-height: 550px;
    overflow: auto;
    overflow-x: hidden;
  }

  .table-package {
    width: 100%;
    border-collapse: collapse;
    // border 1px #ddd solid
    border: none;
  }

  .table-thead {
    border-top: 2px solid rgb(51, 137, 255);

    >tr th {
      width: 294px;
      text-align: center;
      height: 50px;
      font-size: 14px;
      line-height: 50px;
      color: #666;
      font-weight: bold;
      border: 1px solid #e0e0e0;
      border-bottom: 1px solid rgb(51, 137, 255);
      background-color: #f7f7f7;
    }
  }

  .table-tbodys {
    :hover {
      background: #c3e3ff;
    }

    tr {
      text-align: center;
      height: 37px;
      line-height: 37px;
      border: 1px solid #ddd;
      border: none;
      background-color: #fff;
    }

    td {
      width: 294px;
      border: 1px solid #e0e0e0;
      color: #666;
      border-top: none;
      vertical-align: middle;
    }
  }

  .table-tfoot {
    tr>td {
      text-align: center;
      height: 37px;
      line-height: 37px;
      color: #333;
      font-size: 14px;
    }

    .row {
      font-size: 14px;
      background-color: #fff;
      font-weight: bold;

      >td {
        width: 294px;
        text-align: center;
        border: 1px solid #e0e0e0;
        // color: #666;
        border-top: none;
        font-weight: bold;
      }
    }
  }

  .tool-text {
    margin: 0 10px;
    cursor: pointer;
    &.blue {
      color: #3389ff;
    }
    &.red {
      color: #ff3817;
    }
  }

  .hidden {
    display: none;
  }
}
</style>
